import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { pepListFeatureKey, PepListState, reducer as pepListReducer } from './pep-check/pep-list.reducer';
import { tagsFeatureKey, TagsState, reducer as tagsReducer } from './tags/tags.reducer';

export interface RootStore {
  [tagsFeatureKey]: TagsState;
  [pepListFeatureKey]: PepListState;
}

export const rootReducer: ActionReducerMap<RootStore> = {
  tags: tagsReducer,
  pepList: pepListReducer
};
